<template>
  <div class="bg-F2F2F6 pt-12 relative">
    <p class="absolute ff-medium font-34 c-FFFFFF pt-16 w-fullVw text-center">{{
      corpName
    }}</p>
    <img src="@/assets/images/bg-guardian-face.png" alt="" />
    <div class="bg-FFFFFF">
      <div class="lh-36 p-0-16 c-171A1D font-34">
        学生 ( {{ list.length }} )
      </div>

      <div
        class="p-0-8 p-16-0 fb fb-main-start fb-cross-start fb-wrap mb-12 c-171A1D-60"
      >
        <div
          v-for="(item, index) in list"
          :key="`student-${index}`"
          @click="handleFaceInput(item)"
          class="fb fb-col fb-cross-center fb-main-center face-margin"
        >
          <div
            class="face-bg w-76 h-76 bd-radio-8 bg-FFFFFF fb fb-cross-center fb-main-center face-pic hidden"
          >
            <img width="100%" v-if="item.facePicUrl" :src="item.facePicUrl" />
            <i
              v-else
              class="iconfont font-72"
              :class="[item.face ? 'c-006AFE' : 'c-191A26-24']"
              >&#xe67b;</i
            >
          </div>
          <p class="pt-12 font-28 pb-16">{{
            filterName(item.memberName, 4)
          }}</p>
        </div>
      </div>
    </div>

    <div class="bg-FFFFFF mt-12">
      <div class="lh-36 p-0-16 c-171A1D font-34">
        家长 ( {{ guardianList.length }} )
      </div>
      <div
        class="p-0-8 p-16-0 fb fb-main-start fb-cross-start fb-wrap mb-12 c-171A1D-60"
      >
        <div
          v-for="(item, index) in guardianList"
          :key="`guardian-${index}`"
          @click="handleFaceInput(item)"
          class="fb fb-col fb-cross-center fb-main-center face-margin"
        >
          <div
            class="face-bg w-76 h-76 bd-radio-8 bg-FFFFFF fb fb-cross-center fb-main-center face-pic hidden"
          >
            <img width="100%" v-if="item.facePicUrl" :src="item.facePicUrl" />
            <i
              v-else
              class="iconfont font-72"
              :class="[item.face ? 'c-006AFE' : 'c-191A26-24']"
              >&#xe67b;</i
            >
          </div>
          <p class="pt-12 font-28 pb-16">{{
            filterName(item.memberName, 4)
          }}</p>
        </div>
      </div>
    </div>
    <face-rule
      class="fixed top-0 left-0 right-0 bottom-0 w-fullVw h-fullVh bg-F2F2F6 scroll-y z-idx__9"
      v-if="showRule"
      @agree="handleAgree"
      @cancel="handleCancel"
    ></face-rule>
  </div>
</template>

<script>
import mixin from '@/mixin'
import { filterName, faceUrl, setItem, getItem } from '@/utils/comUtils'
import { mcToast } from '@/utils/mcSdkUtils'
import { faceRule } from '@/components'
import { LEAVE_ROLE } from '@/utils/constUtils'
export default {
  name: 'PageFaceInputGuardian',
  mixins: [mixin],
  data() {
    return {
      filterName,
      list: [],
      guardianList: [],
      showRule: false,
      member: {}
    }
  },
  components: { faceRule },
  computed: {},
  created() {},
  mounted() {
    this.getUserFamilyList()
    this.getFaceAuth()
    // this.visibilityChange()
  },
  activated() {
    this.getUserFamilyList()
  },
  methods: {
    visibilityChange() {
      document.addEventListener('visibilitychange', this.visibilityHandler)
    },
    visibilityHandler() {
      const pageVisibility = document.visibilityState
      // 页面变为不可见时触发
      if (pageVisibility === 'hidden') {
        console.log('离开时间点：' + new Date())
      }
      // 页面变为可见时触发
      if (pageVisibility === 'visible') {
        console.log('重新进入时间点：' + new Date())
        this.getUserFamilyList()
      }
    },
    getUserFamilyList() {
      this.getApi('faceFamilyList', { memberId: this.orgUserId }, true).then(
        res => {
          this.list = res.studentList
          this.guardianList = res.guardianList || []
        }
      )
    },
    handleAgree() {
      this.getApi('faceGuardianAgree', {}, true).then(res => {
        if (res === true) {
          mcToast({ msg: '授权成功' })
          setTimeout(() => {
            this.showRule = false
            this.faceInput()
          }, 600)
        }
      })
    },
    handleCancel() {
      this.showRule = false
    },
    handleFaceInput(member) {
      this.member = member
      if (member.facePicUrl) {
        return false
      }
      if (
        !member.agree &&
        +(this.$route.query || {}).currentRole !== LEAVE_ROLE.guardian
      ) {
        this.showRule = true
        return false
      }
      this.faceInput()
    },
    faceInput() {
      const url = faceUrl(this.orgId, this.member.memberId, this.orgUserId)
      // mcOpenLink({ url: url })
      // window.location.href = url
      this.mixinRouter('/full/faceInput/faceFrame', { url })
    },
    getFaceAuth() {
      if (!getItem('faceauth')) {
        // 录脸授权
        this.getApi(
          'getFaceAuth',
          { memberId: this.orgUserId, orgId: this.orgId },
          true
        ).then(res => {
          setItem('faceauth', res)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.face-margin {
  padding: 0 calc((100% - 304px) / 8) 0; //76*4+16
}
.face-bg {
  background: rgba(0, 0, 0, 0.04);
}
.face-pic {
  background-repeat: no-repeat;
  background-position: center center;
}
.c-191A26-24 {
  color: rgb(25, 26, 38, 0.24);
}
.z-idx__9 {
  z-index: 9;
}
.bg-F2F2F6 {
  background: #f2f2f6;
}
</style>
